// extracted by mini-css-extract-plugin
export var PhoneAndLess = "only screen and (max-width: 767px)";
export var root = "mobile-module--root--0f3db";